import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Store } from '@ngrx/store';
import { Lead } from 'src/app/core/models/lead/lead.model';
import { AgentAction } from '../../../agent.actions';

@Component({
    selector: 'app-agent-lead-offer-accepted-dialog',
    templateUrl: './agent-lead-offer-accepted-dialog.component.html',
    styleUrls: ['./agent-lead-offer-accepted-dialog.component.scss'],
    standalone: false
})
export class AgentLeadOfferAcceptedDialogComponent {

  constructor(public dialogRef: MatDialogRef<AgentLeadOfferAcceptedDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public lead: Lead,
    private readonly appStore: Store) {
  }

  onShowInfoClicked() {
    this.appStore.dispatch(AgentAction.openLeadInfoSidenavContent(this.lead))
    this.dialogRef.close()
  }
}
